import * as React from "react";
const SvgTransparent = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", stroke: "none", ...props }, /* @__PURE__ */ React.createElement("circle", { cx: 0, cy: 0, r: 0 }));
export default SvgTransparent;
